import React from "react";
import { useTranslation } from "react-i18next";

/**
 * Responsive, accessible pagination.
 * Desktop: prev + numbered pages + next. Mobile: prev + "Page x of y" + next.
 */
export function Pagination({ page, pages, onChange, testIdPrefix = "pagination" }) {
  const { t } = useTranslation();
  if (pages <= 1) return null;

  const nums = [];
  for (let i = 1; i <= pages; i++) nums.push(i);

  return (
    <nav className="mt-12 flex items-center justify-center gap-2" aria-label="Pagination" data-testid={testIdPrefix}>
      <button
        type="button"
        onClick={() => onChange(page - 1)}
        disabled={page <= 1}
        aria-label={t("common.previous")}
        data-testid={`${testIdPrefix}-prev`}
        className="h-11 px-4 flex items-center justify-center border border-hair text-mut font-techmono text-sm hover:border-cyan hover:text-accent transition-colors disabled:opacity-40 disabled:cursor-not-allowed disabled:hover:border-hair disabled:hover:text-mut"
      >
        ‹
      </button>

      {/* Desktop numbers */}
      <div className="hidden sm:flex items-center gap-2">
        {nums.map((n) => (
          <button
            key={n}
            type="button"
            onClick={() => onChange(n)}
            aria-current={n === page ? "page" : undefined}
            data-testid={`${testIdPrefix}-page-${n}`}
            className={`w-11 h-11 flex items-center justify-center border font-techmono text-sm transition-colors ${
              n === page
                ? "bg-cyan text-ink-900 border-cyan"
                : "border-hair text-mut hover:border-cyan hover:text-accent"
            }`}
          >
            {n}
          </button>
        ))}
      </div>

      {/* Mobile indicator */}
      <span className="sm:hidden font-techmono text-sm text-mut px-3">
        {t("common.page")} {page} {t("common.of")} {pages}
      </span>

      <button
        type="button"
        onClick={() => onChange(page + 1)}
        disabled={page >= pages}
        aria-label={t("common.next")}
        data-testid={`${testIdPrefix}-next`}
        className="h-11 px-4 flex items-center justify-center border border-hair text-mut font-techmono text-sm hover:border-cyan hover:text-accent transition-colors disabled:opacity-40 disabled:cursor-not-allowed disabled:hover:border-hair disabled:hover:text-mut"
      >
        ›
      </button>
    </nav>
  );
}
